<template>
  <div v-if="audit" class="audit-info flex flex-col gap-2 cursor-help" relative>
    <div
      v-if="showCreated && (audit.CreatedOn || audit.CreatedBy)"
      class="inline-flex items-center justify-start gap-2.5 rounded-full border border-surface-200 dark:border-surface-700 text-xs font-medium min-w-16 w-fit pr-2 hover:bg-surface-100/50 dark:hover:bg-surface-800/20 hover:text-rch-black dark:hover:text-surface-200 hover:ring-surface-600/20 hover:border-surface-600/20 dark:hover:border-surface-700/60"
      v-tooltip.top="{
        value: audit.CreatedBy || 'Unknown',
        class: 'w-fit min-w-fit max-w-[400px] text-sm',
      }"
    >
      <span
        class="inline-flex size-6 items-center justify-center rounded-full bg-surface-0 dark:bg-surface-900"
      >
        <UserCircleIcon class="size-4" />
      </span>
      <span>{{ formatDateForDisplay(audit.CreatedOn as string) }}</span>
    </div>
    <div
      v-if="showModified && (audit.LastModifiedOn || audit.LastModifiedBy)"
      class="inline-flex items-center justify-start gap-2.5 rounded-full border border-surface-200 dark:border-surface-700 text-xs font-medium min-w-16 w-fit pr-2 hover:bg-cyan-50/50 dark:hover:bg-cyan-900/20 hover:text-cyan-700 dark:hover:text-cyan-200 hover:ring-cyan-600/20 hover:border-cyan-600/20 dark:hover:border-cyan-700/60"
      v-tooltip.top="{
        value: audit.LastModifiedBy || 'Unknown',
        class: 'w-fit min-w-fit max-w-[400px] text-sm',
      }"
    >
      <span
        class="inline-flex size-6 items-center justify-center rounded-full bg-surface-0 dark:bg-surface-900"
      >
        <UserCircleIcon class="size-4" />
      </span>
      <span>{{ formatDateForDisplay(audit.LastModifiedOn as string) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UserCircleIcon } from '@heroicons/vue/24/outline'
import { formatDateForDisplay } from '@/util/dateUtils'
import type { AuditRecord } from '@/types/audit'

interface Props {
  audit: AuditRecord | null | undefined
  showCreated?: boolean
  showModified?: boolean
}

withDefaults(defineProps<Props>(), {
  showCreated: true,
  showModified: true,
})
</script>
